import moment from 'moment';
import {BillingBlockRun} from 'src/core/data/api/BillingBlock';
import * as ranges from 'src/helpers/date';
import {Period} from './provider';

// Same limit and shortcuts as the tracking reports.
const MAX_DAYS = 31;
const DAY = 'YYYY-MM-DD';

export const localDay = (instant: string) => moment(instant).format(DAY);

export const PERIOD_PRESETS = [
  {id: 'nowSofar', labelId: 'reportToday'},
  {id: 'yesterday', labelId: 'reportYesterday'},
  {id: 'currentWeekSoFar', labelId: 'reportThisWeek'},
  {id: 'lastWeek', labelId: 'reportPreviousWeek'},
  {id: 'currentMonthSoFar', labelId: 'reportCurrentMonth'},
  {id: 'lastMonth', labelId: 'reportPreviousMonth'},
] as const;

export type PeriodPreset = typeof PERIOD_PRESETS[number]['id'];

export const presetPeriod = (preset: PeriodPreset): Period => {
  const {from, to} = ranges[preset]();
  return {from: localDay(from), to: localDay(to), preset};
};

export const defaultPeriod = (runs: BillingBlockRun[]): Period | null => {
  if (runs.length === 0) return null;
  const newest = runs.reduce((latest, run) => (moment(run.startedAt).isAfter(latest.startedAt) ? run : latest));
  const day = localDay(newest.startedAt);
  return {from: day, to: day};
};

// Day strings in DAY format sort the same as the dates they name.
export const filterRuns = (runs: BillingBlockRun[], {from, to}: Period) => runs.filter((run) => {
  const day = localDay(run.startedAt);
  return day >= from && day <= to;
});

export const validatePeriod = ({from, to}: Period) => {
  if (!from || !to) return 'billingBlockPeriodRequired';
  if (to < from) return 'billingBlockPeriodInverted';
  if (moment(to, DAY).diff(moment(from, DAY), 'days') + 1 > MAX_DAYS) return 'billingBlockPeriodTooLong';
  return null;
};
